import {
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Button,
  Input,
  Col,
  CardBody,
  Spinner,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
} from "reactstrap";
// core components
import OnlyHeader from "components/Headers/OnlyHeader.js";
import { getAllOrders } from "store/actions/SellersAction";
import debounce from "lodash/debounce";
import { DotPulse } from "@uiball/loaders";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { MdArrowBackIosNew } from "react-icons/md";

const OrderDetail = () => {
  const { orders, active, lastDocument, loader } = useSelector(
    (state) => state.sellers
  );
  const { id } = useParams();
  const dispatch = useDispatch();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [lastDocuments, setLastDocuments] = useState();
  const history = useHistory();

  const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);

  const handleStatusFilter = async (status) => {
    setSearch("");
    setSelectedStatus(status);
    setIsLoading(true);

    try {
      await dispatch(getAllOrders(null, id, "", status));
      setIsLoading(false);
    } catch (error) {
      console.error("An error occurred:", error);
      setIsLoading(false);
    }
  };

  const handleSearch = debounce(async (e) => {
    try {
      console.log(e.target.value, "value");
      await dispatch(getAllOrders(null, id, e.target.value));
      setIsLoading(false);
    } catch (error) {
      console.error("An error occurred:", error);
      setIsLoading(false);
    }
  }, 3000);

  const handleLoadMore = () => {
    setSearch("");
    dispatch(getAllOrders(lastDocuments, id, "", selectedStatus));
  };
  useEffect(() => {
    setLastDocuments(lastDocument);
  }, [lastDocument]);

  useEffect(() => {
    dispatch(getAllOrders(null, id, ""));
  }, [id]);
  return (
    <>
      <OnlyHeader />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 ">
                <div className="d-lg-flex d-md-flex justify-content-between align-items-center mx-0 mx-lg-3">
                  <h3 className="mb-0">
                    {" "}
                    <MdArrowBackIosNew
                      className="mx-2"
                      style={{ cursor: "pointer" }}
                      onClick={() => history.goBack()}
                    />
                    Orders
                  </h3>
                  <div className="position-relative mt-2">
                    <Input
                      type="text"
                      placeholder="Search"
                      onChange={(e) => {
                        setIsLoading(true);
                        handleSearch(e);
                      }}
                    />
                    {isLoading ? (
                      <span
                        style={{
                          position: "absolute",
                          top: "20px",
                          right: "10px",
                        }}
                      >
                        <DotPulse size={25} speed={1.3} color="black" />
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                  <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                    <DropdownToggle caret color="primary mt-2">
                      {selectedStatus ? selectedStatus : "All Status"}
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem onClick={() => handleStatusFilter("")}>
                        All Status
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => handleStatusFilter("completed")}
                      >
                        Completed
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => handleStatusFilter("dispatched")}
                      >
                        Dispatched
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => handleStatusFilter("confirmed")}
                      >
                        Confirmed
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => handleStatusFilter("delivered")}
                      >
                        Delivered
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </CardHeader>
              <Row>
                <Col>
                  <Card className="mb-4">
                    <CardBody className="mainCardHeader">
                      <Table responsive>
                        <thead className="thead-light">
                          <tr>
                            <th scope="col">Order Id</th>
                            <th scope="col">Order Date</th>
                            <th scope="col">Customer Name</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        {loader ? (
                          <tbody>
                            <tr>
                              <td colSpan="5" className="text-center">
                                <Spinner size="lg" />
                              </td>
                            </tr>
                          </tbody>
                        ) : orders?.length === 0 ? (
                          <tbody>
                            <tr className="mt-2">
                              <td>No order found.</td>
                            </tr>
                          </tbody>
                        ) : (
                          <tbody>
                            {orders &&
                              orders.map((order, index) => (
                                <tr key={index}>
                                  <td scope="row">
                                    <span className="mb-0 text-sm">
                                      {order?.orderId}
                                    </span>
                                  </td>
                                  <td>
                                    {order?.createdAt
                                      .toDate()
                                      .toLocaleDateString()}
                                  </td>
                                  <td>
                                    {order?.username || order?.customerId || ""}
                                  </td>
                                  <td>
                                    {order?.status === "completed" && (
                                      <span className="badge badge-success">
                                        Completed
                                      </span>
                                    )}
                                    {order?.status === "dispatched" && (
                                      <span className="badge badge-info">
                                        Dispatched
                                      </span>
                                    )}
                                    {order?.status === "confirmed" && (
                                      <span className="badge badge-warning">
                                        Confirmed
                                      </span>
                                    )}
                                    {order?.status === "delivered" && (
                                      <span className="badge badge-primary">
                                        Delivered
                                      </span>
                                    )}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        )}
                      </Table>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Card>
            <div className="d-flex justify-content-center align-items-center mt-3">
              {loader == false && orders.length > 0 ? (
                <>
                  <p className="text-center">
                    {active == false ? "No more items" : ""}
                  </p>
                  <Button
                    onClick={handleLoadMore}
                    className="bg-primary mx-3 text-secondary  mb-2 btn-sm"
                    disabled={active ? false : true}
                  >
                    Load more
                  </Button>
                </>
              ) : (
                "Orders not found !"
              )}
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default OrderDetail;
